export enum RestrictedAreaType {
    SCHOOL_PATH = "0",
    CONSTRUCTION_SITE = "1"
  }
  